document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-publication-article]');
  var archive = document.querySelector('[data-publication-archive]');
  if (archive) {
    var topicButtons = archive.querySelectorAll('[data-publication-topic]');
    var categoryItems = archive.querySelectorAll('[data-publication-category]');
    var listHeading = archive.querySelector('[data-publication-list-heading]');
    var latest = archive.querySelector('.publication__topics a');
    topicButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var topic = button.dataset.publicationTopic;
        var isActive = button.getAttribute('aria-pressed') === 'true';
        topicButtons.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
        categoryItems.forEach(function (item) { item.hidden = !isActive && item.dataset.publicationCategory !== topic; });
        if (latest) latest.removeAttribute('aria-current');
        if (isActive) { if (latest) latest.setAttribute('aria-current', 'page'); }
        else button.setAttribute('aria-pressed', 'true');
        if (listHeading) listHeading.textContent = isActive ? listHeading.dataset.defaultHeading : button.textContent;
      });
    });
    if (latest && topicButtons.length) {
      latest.addEventListener('click', function (event) {
        if (location.pathname.replace(/\/$/, '') !== latest.pathname.replace(/\/$/, '')) return;
        event.preventDefault();
        topicButtons.forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
        categoryItems.forEach(function (item) { item.hidden = false; });
        latest.setAttribute('aria-current', 'page');
        if (listHeading) listHeading.textContent = listHeading.dataset.defaultHeading;
      });
    }
  }
  if (!root) return;

  var feedback = root.querySelector('[data-publication-feedback]');
  if (feedback) {
    feedback.focus({ preventScroll: true });
    feedback.scrollIntoView({ block: 'center' });
  }

  var share = root.querySelector('[data-publication-share]');
  var shareFeedback = root.querySelector('[data-publication-share-feedback]');
  if (share && shareFeedback) {
    share.addEventListener('click', async function () {
      var url = share.dataset.shareUrl;
      try {
        if (navigator.share) {
          await navigator.share({ title: share.dataset.shareTitle, url: url });
          return;
        }
        await navigator.clipboard.writeText(url);
        shareFeedback.textContent = root.dataset.shareCopied;
      } catch (error) {
        if (error.name === 'AbortError') return;
        shareFeedback.textContent = root.dataset.shareFallback + ' ' + url;
      }
    });
  }
});
